import React from "react"
import { useTranslation } from "react-i18next";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import ButtonSvg from "../../assets/svg/ButtonSvg";
export const Label = ({value,onChange,required,labelText,type ,name})=>{
  const { t } = useTranslation();
  return(
<div class="relative w-full my-4">
    <input type="text" id={labelText} class="block px-2.5 pb-2.5 pt-4 w-full body-1 text-n-2 bg-n-8 rounded-lg border border border-n-1/50 appearance-none  focus:outline-none focus:ring-0 focus:border-color-1 peer" placeholder=" " 
    value={value}
    onChange={onChange}
    required={required}
    type={type}
    name={name}
    />
    <label for={labelText} class="absolute text-sm text-gray-500  duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-n-8  px-2 peer-focus:px-2 peer-focus:text-color-1  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:bg-n-8 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 body-1">{t(labelText)}</label>
</div>
    )
}


export const TextArea = ({value,onChange,required,labelText,name,type,row})=>{
  const { t } = useTranslation();
  return(
<div class="relative w-full my-4">
    <textarea type="text" id={labelText} class="block px-2.5 pb-2.5 pt-4 w-full body-1 text-n-2 bg-n-8 rounded-lg border border border-n-1/50 appearance-none  focus:outline-none focus:ring-0 focus:border-color-1 peer" placeholder=" " 
    value={value}
    onChange={onChange}
    required={required}
    name={name}
    row={row}
    type={type}
    />
    <label for={labelText} class="absolute text-sm text-gray-500  duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-n-8  px-2 peer-focus:px-2 peer-focus:text-color-1  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:bg-n-8 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 body-1">{t(labelText)}</label>
</div>
    )
}

export const Select = ({value,onChange,required,labelText,type ,name,AllServices})=>{
  const { t } = useTranslation();
  return(
<div class="relative w-full my-4">
<label for={labelText} className="block mb-2 text-sm font-medium text-n-1/50 body-1">{t(labelText)}</label>
    <select className="bg-n-8 border  border-n-1/50 text-n-2  text-sm rounded-lg focus:ring-color-1 body-1 focus:border-color-1 block w-full p-3"
  
    value={value}
    onChange={onChange}
    required={required}
    name={name}
    >
    <option selected className="">{""}</option>
    {AllServices?.map((service)=>
               <option value={service.title}>
          {t(service.title)}
          </option>
    )}

   
        </select>
</div>
    )
}



export const Button = ({ className, children, px, white,isLoading }) => {
  const classes = `button relative inline-flex items-center justify-center h-11 transition-colors hover:text-color-1 ${white ? "text-n-8" : "text-n-1"} ${className || ""}`;
  const spanClasses = "relative z-10";

  
 const Spiner=()=>(
<div role="status">
    <svg aria-hidden="true"  class="w-5 h-5 text-n-2 animate-spin mx-2 dark:text-gray-600 fill-color-1 " viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
</div>

      )
      
    const renderButton = () => (
    <button className={`${classes} ${isLoading ? "px-3":" px-7" }`} type="submit">
      <span className={spanClasses}>{children}</span>
      {isLoading && <Spiner/>}
      {ButtonSvg(white)}
    </button>
  );

  return renderButton();
};






